import { format } from "date-fns";

export interface ScheduleResult {
  Credits: number;
  StartDateString: string;
  EndDateString: string;
  TimeZone: string;
  Price: string;
  LiveEventProductId?: number;
}

export interface CourseInstance {
  CPECredit: number;
  Price: number;
}

export type Webinar = {
  ID: number;
  CourseTitle: string;
  Acronym?: string;
  ScheduleResults: ScheduleResult[];
  IsNew?: boolean;
  CourseInstanceList: CourseInstance[];
  isMobileCourse?: boolean;
  TotalCredits?: number;
  DeliveryFormatName: string;
  FieldOfStudyName: string;
};

export const fetchWebinars = async function () {
  try {
    const res = await fetch(
      "/CourseFinder/GetActiveCourses?deliveryformat=webinar"
    );
    if (res.status !== 200) throw new Error("Could not fetch webinars");
    return await res.json();
  } catch (error: any) {
    alert(error.message);
  }
};

export const hasScheduledResults = (webinar: Webinar) =>
  webinar.hasOwnProperty("ScheduleResults") &&
  typeof webinar.ScheduleResults !== "undefined" &&
  webinar.ScheduleResults &&
  webinar.ScheduleResults.length > 0;

export const getWebinarPrice = (webinar: Webinar, scheduledPrice: string) =>
  scheduledPrice
    ? scheduledPrice
    : `$${parseFloat(String(webinar.CourseInstanceList[0].Price)).toFixed(2)}`;

export const getWebinarCredits = (webinar: Webinar, scheduledCredits: number) =>
  scheduledCredits > 0
    ? scheduledCredits
    : webinar.CourseInstanceList[0].CPECredit;

export const getWebinarStartDateAndTime = function (
  StartDateString: string,
  EndDateString: string,
  TimeZone: string
) {
  const startTime = new Date(StartDateString);
  const endTime = new Date(EndDateString);

  const formattedStartDate = format(startTime, "MMM dd, yyyy");
  const formattedStartTime = format(startTime, "ha");
  const formattedEndTime = format(endTime, "ha");

  return [
    formattedStartDate,
    `${formattedStartTime} - ${formattedEndTime} ${TimeZone}`,
  ];
};

export const today = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const addToCart = (payload: {
  CourseID: number;
  ProductID: number;
  Acronym: string;
  ProductCodes: number;
  UnitPrice: number;
  IsMobile: boolean;
  ProductCredits: number;
  Title: string;
  ProductDate: string;
  ProductTime: string;
}) => {
  const addToCartLocalStorageKey = "clientLocalCart";

  const addToCartPayload = {
    UniqueID: getUniqueID(),
    ProductType: 5,
    EBPrice: 0,
    Quantity: 1,
    TotalPrice: 0,
    MediaDesc: "Webinar",
    ProductDesc: "",
    PrivacyChoice: "",
    // ---- dynamic data
    CourseID: payload.CourseID, //webinar.ID,
    ProductID: payload.ProductID,
    ProductCodes: payload.ProductCodes, // webinar.ScheduleResults.length,
    ProductCode: payload.Acronym, //webinar.Acronym,
    Title: payload.Title, // webinar.CourseTitle,
    UnitPrice: payload.UnitPrice, // parseFloat(webinar.ScheduleResults[0].Price.slice(1)),
    IsMobile: payload.IsMobile, //webinar.isMobileCourse,
    ProductCredits: payload.ProductCredits, // webinar.TotalCredits,
    ProductDate: payload.ProductDate,
    ProductTime: payload.ProductTime,
  };

  const currentCart = JSON.parse(
    localStorage.getItem(addToCartLocalStorageKey) || "[]"
  );

  const newCart = [...currentCart, addToCartPayload];

  localStorage.setItem(addToCartLocalStorageKey, JSON.stringify(newCart));

  window.open(
    `/ExpressCheckout/Checkout`
  );
};

export const getUniqueID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      // eslint-disable-next-line
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export function registerAnalyticsEvent(eventAction: undefined | string) {
  if (!eventAction) return;

  const googleAnalytics = (window as any).ga;

  if (!googleAnalytics) {
    console.error("Google analytics not yet loaded.");
    return;
  }

  googleAnalytics("send", {
    hitType: "event",
    eventCategory: "TR_redesign",
    eventAction: eventAction,
    eventLabel: "TR_redesign",
    hitCallback: function () {
      console.debug(`GA registered event - ${eventAction}`);
    },
  });
}
